/* Драбина бонусів: сама кладе в кошик подарунки досягнутої ланки й прибирає їх,
 * коли сума падає нижче порога.
 *
 * Налаштування бере з `#cart-ladder-config`, який малює snippets/cart-gift-ladder
 * (ланки поточного ринку з товаром, пороги в центах). Позиції драбини мають мітку
 * `_ladder_gift` = id ланки; до 0.1 їх опускає функція знижки «Подарунок від суми»
 * (sistersaroma-cart-gift), вона ж повторно перевіряє поріг і кількість - тут лише
 * зручність для покупця, а не захист.
 *
 * ПРАВИЛО: дарує НАЙВИЩИЙ досягнутий рівень - його набір товарів, по штуці
 * кожного. Вищий рівень МІНЯЄ набір, а не додає до попереднього: подарунки
 * нижчого рівня з кошика прибираються. Сума - кошик без
 * подарунків і до знижок, та сама, що бере функція.
 */
(() => {
  const SRC = 'cart-ladder';
  const GIFT_PROPS = ['_gift_timer', '_ladder_gift', '_promo_gift', '_gift'];
  let busy = false;
  let again = false;

  const readCfg = () => {
    const el = document.getElementById('cart-ladder-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  };

  const isGift = (it) => GIFT_PROPS.some((k) => it.properties && it.properties[k]);

  async function sync() {
    const cfg = readCfg();
    if (!cfg || !window.CartAPI) return;
    if (busy) { again = true; return; }
    busy = true;
    /* Поки драбина рахує й міняє подарунки, шухляда не малює проміжних станів
       (cart-drawer.js чекає на cart:release). */
    document.dispatchEvent(new Event('cart:hold'));
    try {
      const cart = await window.CartAPI.get();
      const items = cart.items || [];
      const paid = items.filter((it) => !isGift(it)).reduce((s, it) => s + (it.original_line_price || 0), 0);

      /* Що має лежати в кошику: id ланки -> {варіант, кількість}. */
      /* Набір найвищого досягнутого рівня: варіант -> скільки штук. */
      let best = null;
      if (cfg.enabled && paid > 0) {
        for (const t of cfg.tiers || []) {
          if (paid >= t.amount && (!best || t.amount >= best.amount)) best = t;
        }
      }
      const want = new Map();
      for (const v of (best && best.items) || []) want.set(String(v), (want.get(String(v)) || 0) + 1);

      const updates = {};
      for (const it of items) {
        const tag = it.properties && it.properties._ladder_gift;
        if (!tag) continue;
        const v = String(it.variant_id);
        const can = best && String(tag) === String(best.id) ? (want.get(v) || 0) : 0;
        const keep = Math.max(0, Math.min(it.quantity, can));
        if (best && String(tag) === String(best.id)) want.set(v, can - keep);
        if (keep !== it.quantity) updates[it.key] = keep;
      }

      if (Object.keys(updates).length) {
        await window.CartAPI.update({ updates }, { source: SRC });
      }
      const add = [];
      for (const [v, n] of want) {
        if (n > 0) add.push({ id: Number(v), quantity: n, properties: { _ladder_gift: String(best.id) } });
      }
      if (add.length) {
        await window.CartAPI.add(add, { source: SRC });
      }
    } catch (e) {
      /* Товару нема в наявності або кошик зайнятий - мовчки: при наступній
         зміні кошика спробуємо знову. */
    } finally {
      busy = false;
      document.dispatchEvent(new Event('cart:release'));
      if (again) { again = false; sync(); }
    }
  }

  const start = () => {
    window.PubSub?.subscribe(window.EVENTS?.cartUpdate, ({ source }) => { if (source !== SRC) sync(); });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
